import { UI } from '@genial/components';
import * as NB from 'native-base';
import React from 'react';

/*
╔═══════════════════════════════════════════════════════╗
╣                                                       ╣
╣                                                       ╣
║                         Icon                          ║
║                        Title                          ║
║                     Description                       ║
║                        Button                         ║
║                                                       ║
║                                                       ║
╚═══════════════════════════════════════════════════════╝
*/

export interface TemplateNotFoundAreas {
  title: string;
  description: string;
  onPress: () => void;
}

export const TemplateNotFound = (props: TemplateNotFoundAreas) => {
  const errorTitleDefault = 'Erro.';
  const errorDescriptionDefault = 'Não foi possível recuperar informações';

  return (
    <NB.VStack height={'100vh'} width="100%" alignItems={'center'} justifyContent={'center'}>
      <NB.Center>
        <NB.Box pb={'15.12px'}>
          <UI.Illustration name="NotFoundIllustration" testId="qa" />
        </NB.Box>
        <UI.Heading testId="qa" size="h2">
          {props?.title || errorTitleDefault}
        </UI.Heading>
        <UI.Text testId="qa" size="h2" pt={'9px'} pb={'14px'} textAlign={'center'}>
          {props?.description || errorDescriptionDefault}
        </UI.Text>
        {props.onPress && (
          <NB.Button variant="textLink" size={'sm'} onPress={props.onPress}>
            acessar novamente
          </NB.Button>
        )}
      </NB.Center>
    </NB.VStack>
  );
};
